import catchReduxError from './catch-redux-error';
import errorCatcher from './error-catcher';

export default {
  catchReduxError,
  errorCatcher,
};
